import Prism from "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "./CodeBlock.css"


// Load the languages you actually use:
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-c";
import "prismjs/components/prism-cpp";
import "prismjs/components/prism-python";
import "prismjs/components/prism-java";
import "prismjs/components/prism-scala";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-rust";
import "prismjs/components/prism-nasm";
import "prismjs/components/prism-verilog";
import "prism-themes/themes/prism-vsc-dark-plus.css";

import { useEffect, useRef, useMemo, useState } from "react";

// Prism.manual = true;

export default function CodeBlock({ code = "", language = "JavaScript" }) {
  const codeRef = useRef(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const prismLangMap = useMemo(() => ({
    "C++":        "cpp",
    "C":          "c",
    "Java":       "java",
    "Python":     "python",
    "Scala":      "scala",
    "JavaScript": "javascript",
    "Bash":       "bash",
    "Rust":       "rust",
    "x86":        "nasm",    // NASM syntax for x86 assembly
    "Verilog":    "verilog",
  }), []);

  const lang = prismLangMap[language] || "javascript";

  useEffect(() => {
    if (codeRef.current) {
      Prism.highlightElement(codeRef.current);
    }
  }, [code, lang]); // re-run when language changes too

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      console.log("Copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };
  


  return (

    <>
    <div className="tooltip-wrapper">
            <span className="copy-code-tooltip"  style={{ display: tooltipVisible ? "flex" : "none" }}>
              Copy code
            </span>
    </div>

    <div className="attempts-outer-wrapper">


      <div className="copy-button-container">

        <button className="copy-paste-submission-button" onClick={copy}
         onMouseEnter={() => setTooltipVisible(true)}
         onMouseLeave={() => setTooltipVisible(false)}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="26.88" height="26.88" viewBox="0 0 30 30" fill="none" className="copy-paste">
              <rect x="8" y="3" width="11" height="14" rx="2" ry="2"
                    stroke="#6b6b6b" stroke-width="1.5" fill="none" />
              <rect x="3" y="8" width="11" height="13" rx="2" ry="2"
                    stroke="#6b6b6b" stroke-width="1.5" fill="none" />
            </svg>
        </button>
      </div>
      
      

      <pre className="submission-code-block-wrapper" >
          <code ref={codeRef} className={`language-${lang}`}
            style={{
                width: "85%",
                overflowWrap: "break-word",
                whiteSpace: "pre-wrap",
                backgroundColor: "#1e1e1e"
            }}
          >
            {code}
          </code>
      </pre>
      <div className="code-spacing-div" />
    </div>
   
    

    </>




  );
}
